<template>
    <div id="pay-app-entry">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">

// more payment custom page css

.nav-payment-tab
{
    a.nav-link {
        cursor: pointer;
        img {
            display:block;
            margin:auto;
            filter: grayscale(100%);
        }
    }

    a.nav-link.active {
        color:#a244ea;
        cursor: pointer;
        img {
            display:block;
            margin:auto;
            filter:none;
        }
    }
}

.payment-tab-content
{
    // background-color: #ccc;
    width:100%;
    padding:10px;
}

.badge.badge-payment-date
{
    font-size:16px;
    border-radius:10px;
}

.table.table-payment
{
    margin: 10px auto;
    td {
        border-bottom:1px solid #dee2e6;
        background-color: #f0f0f0;
    }

    td:nth-child(1) {
        font-weight: bold;
    }
}
// end more payment custom page css
</style>
